<template>
  <div class="content">
    <div id="md-hddb"></div>
    <!-- 顶部下载 -->
    <!-- <top-download></top-download> -->
    <!-- 顶部导航栏 -->
    <top-nav
      ref="topNav"
      v-if="$route.path.includes('/home') || $route.path.includes('/menu')"
      :key="timer"
      @getLoging="getLoging"
    ></top-nav>

    <!-- 固定头部占位元素 -->
    <div
      v-if="$route.path.includes('/home') || $route.path.includes('/menu')"
      style="height: 70px"
    ></div>

    <!-- 公告栏 -->
    <div v-if="$route.path.includes('/home')" class="otag-gg" @click="showNoticePopup = true">
      <van-notice-bar class="notice-bar-style">
        <template #left-icon>
          <!-- 公告喇叭:内联 SVG 取代黄色 PNG(通知=火焰橙;fill 经 style 注入,属性不支持 var) -->
          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            class="m-r-10 notice-bar-icon"
            style="fill: var(--vk-brand)"
            aria-hidden="true"
          >
            <path d="M3 10.5v3A1.5 1.5 0 0 0 4.5 15H6l9 4.5V4.5L6 9H4.5A1.5 1.5 0 0 0 3 10.5Z" />
            <path d="M17 8a4 4 0 0 1 0 8v-2a2 2 0 0 0 0-4V8Z" />
          </svg>
        </template>
        <div class="d-flex notice-bar-text">
          {{ announcementText }}
        </div>
      </van-notice-bar>
    </div>

    <!-- 公告详情弹窗 -->
    <van-popup v-model="showNoticePopup" round :close-on-click-overlay="true" class="notice-popup">
      <div class="notice-popup__content">
        <div class="notice-popup__header">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="#ff5a1f"><path d="M12 22c1.1 0 2-.9 2-2h-4a2 2 0 002 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/></svg>
          <span>{{ $lang.notice_title || 'Notice' }}</span>
          <van-icon name="cross" size="18" color="var(--vk-t2)" @click="showNoticePopup = false" />
        </div>
        <div v-if="announcementListForDisplay.length" class="notice-popup__body">
          <div
            v-for="(item, index) in announcementListForDisplay"
            :key="item.id || index"
            class="notice-popup__item"
          >
            <div v-if="item.title" class="notice-popup__item-title">{{ item.title }}</div>
            <div>{{ item.content || item.title }}</div>
          </div>
        </div>
        <div v-else class="notice-popup__body">
          {{ announcementText }}
        </div>
      </div>
    </van-popup>

    <div
      v-if="$route.path.includes('/home') && bannerList.length"
      class="content-swiper-bg"
      style="margin-top: 10px"
    >
      <van-swipe
        ref="bannerSwipe"
        :autoplay="3500"
        class="swipe-fixed-height"
        :show-indicators="false"
        @change="onBannerChange"
      >
        <van-swipe-item
          v-for="(item, index) in bannerList"
          :key="index"
          @click="onBannerClick(item)"
        >
          <img class="content-swiper--img" :src="item.advertisementImg" />
        </van-swipe-item>
      </van-swipe>
      <!-- 左右箭头按钮 -->
      <div class="banner-arrow-wrap">
        <div class="banner-arrow banner-arrow-left" @click="bannerPrev">
          <van-icon name="arrow-left" size="16" color="#ffffff" />
        </div>
        <div class="banner-arrow banner-arrow-right" @click="bannerNext">
          <van-icon name="arrow" size="16" color="#ffffff" />
        </div>
      </div>
      <!-- Banner 指示器 -->
      <div class="banner-indicators">
        <span
          v-for="(item, index) in bannerList.length"
          :key="index"
          class="banner-dot"
          :class="{ active: currentBannerIndex === index }"
        ></span>
      </div>
    </div>
    <!-- 二级路由出口 -->
    <keep-alive v-if="$route.meta.keepAlive">
      <router-view> </router-view>
    </keep-alive>
    <router-view v-else></router-view>

    <!-- 底部导航栏 -->
    <van-tabbar
      v-if="
        !$route.path.includes('/Country') &&
        !$route.path.includes('/Crowdfunding')
      "
      v-model="active"
      class="custom-tabbar"
      :border="false"
    >
      <van-tabbar-item
        v-for="(item, index) in tabList"
        :key="index"
        @click="handleTabClick(item, index)"
      >
        <span>{{ item.title }}</span>
        <template #icon>
          <tab-bar-icon :name="item.key" />
        </template>
      </van-tabbar-item>
    </van-tabbar>

    <!-- 登录&&注册 -->
    <login v-model="showPopup" overlay @close-key="close"></login>
    <!-- 大转盘 -->
    <!-- <lucky-roulette
      v-model="isShowPopup"
      @login-key="LoginKey"
      overlay
    ></lucky-roulette> -->
    <!-- <div v-if="!['/Country'].includes($route.path)" class="fj-cont">
      <div v-if="isFjShow" class="d-flex">
        <img
          class="fj-cont-i"
          @click="goTofj(1)"
          src="../../assets/img/common/img_tg.png"
          width="50"
        />
      </div>
    </div> -->
    <!-- <van-popup
      v-if="['/lottery', '/home'].includes($route.path)"
      v-model="showDialog"
      class="custom-popup2"
      :closeable="false"
      :close-on-click-overlay="false"
    >
      <div v-if="isff2" class="cont-redim"></div>

      <div v-if="isff" class="cont-redim2"></div>

      <div v-if="isff2" class="d-flex-s m-t-10">
        <div class="d-flex">
          <van-checkbox
            v-model="agree"
            shape="square"
            icon-size="16px"
            icon-color="#202A39"
            style="
              border: 1px solid #6f7887;
              margin-right: 3px;
              border-radius: 5px;
            "
          ></van-checkbox>
          <p style="color: #ffffff; font-size: var(--vk-fs-xs)">{{ $lang.home_txt7 }}</p>
        </div>
        <div class="d-flex">
          <van-checkbox
            v-model="agree2"
            shape="square"
            icon-size="16px"
            icon-color="#202A39"
            style="
              border: 1px solid #6f7887;
              margin-right: 3px;
              border-radius: 5px;
            "
          ></van-checkbox>
          <p style="color: #ffffff; font-size: var(--vk-fs-xs)">{{ $lang.home_txt8 }}</p>
        </div>
      </div>
      <img
        class="m-t-10"
        @click="closeF()"
        src="../../assets/img/lucky_jackpot/img_cancel.png"
        width="38"
      />
    </van-popup> -->
    <!-- 活动 -->
    <activity-popup
      v-if="$route.path.includes('/home')"
      v-model="isShowPopup2"
      @closeActive="closeActive"
      @closeActive2="closeActive2"
    ></activity-popup>
  </div>
</template>

<script>
// import TopDownload from '../../components/TopDownload.vue' //顶部下载
import TopNav from '../../components/TopNav.vue' //顶部导航栏
import TabBarIcon from '../../components/TabBarIcon.vue' //底部 tabbar 线性图标(currentColor)
import {
  GetCsLink,
  Init,
  VnRechargeInitS,
  GameBalanceList,
  WithdrawInit,
  ActivitygetRegisterAward,
  GetInvitationID,
  GetBannerList,
  SystemAnnouncement
} from '@/api/common'
import { consumeOpenLoginAfterPlatformSwitch } from '@/utils/platformAuth'
import { safeGetStorageItem, safeLocalStorage, safeRemoveStorageItem, safeSessionStorage, safeSetStorageItem } from '@/utils/safeStorage'
import { h5Text } from '@/utils/h5I18n'
import {
  getTodayString as readTodayString,
  isOkResponse,
  isReadableOkResponse,
  isNeedLogin,
  openCurrentUrl,
  responseContent,
  responseFailMessage,
  safeObject,
  safeString,
  showLogin,
  sortByOrderDesc
} from './safeLayout'
import {
  activeTabIndexFromPath,
  buildLayoutTabEntries,
  isProtectedLayoutTab
} from './layoutTabs'
import { openCustomerServiceUrl } from './csLink'

function getLocalStorage() {
  try {
    if (typeof safeLocalStorage === 'function') return safeLocalStorage()
  } catch (e) { return null }
  return null
}

function getSessionStorage() {
  try {
    if (typeof safeSessionStorage === 'function') return safeSessionStorage()
  } catch (e) { return null }
  return null
}

function getLayoutAnchorElement() {
  try {
    if (typeof document === 'undefined' || !document || typeof document.getElementById !== 'function') return null
    const target = document.getElementById('md-hddb')
    if (!target || typeof target.scrollIntoView !== 'function') return null
    return target
  } catch (e) {
    return null
  }
}

function scrollWindowTop() {
  try {
    if (typeof window !== 'undefined' && window && typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0)
    }
  } catch (e) {
    // Ignore scroll failures in restricted browser shells.
  }
}

const GENERIC_LAYOUT_FAILURE_RE = /^(request failed|network error|\[object object\])$/i
const TECHNICAL_LAYOUT_FAILURE_RE = /(技术错误|技术异常|technical[ _-]?(error|exception)|request failed|axios(?:error)?|\b(typeerror|referenceerror|syntaxerror|rangeerror)\b|\b(econn[a-z_]*|enotfound|etimedout|eai_again|socket hang up)\b|\b(java\.|sql(?:exception)?|select\s+.+\s+from|insert\s+into|update\s+.+\s+set|delete\s+from)\b|\bat\s+[\w.$<>]+(?:\s|\())/i
const LAYOUT_UNAVAILABLE_FLAG_KEYS = [
  'routeUnavailable',
  'route_unavailable',
  'readUnavailable',
  'read_unavailable',
  'readBlocked',
  'read_blocked',
  'readFailure',
  'read_failure',
  'dataUnavailable',
  'data_unavailable',
  'backendBlocked',
  'backend_blocked',
  'actionBlocked',
  'action_blocked',
  'writeBlocked',
  'write_blocked',
  'blocked',
  'fallback',
  'fallbackUsed',
  'fallback_used',
  'mock',
  'mockMode',
  'mock_mode',
  'unimplemented',
  'notImplemented',
  'not_implemented',
  'notSupported',
  'not_supported',
  'unsupported',
  'technicalError',
  'technical_error',
  'technicalException',
  'technical_exception',
  'technicalMarker',
  'technical_marker',
  'backendFailure',
  'backend_failure'
]
const LAYOUT_UNAVAILABLE_TEXT_KEYS = [
  'status',
  'state',
  'result',
  'code',
  'errorCode',
  'success',
  'msg',
  'message',
  'errorMsg',
  'errorMessage',
  'reason',
  'desc',
  'description'
]

function layoutFallbackMessage(...messages) {
  const message = messages
    .map((value) => safeString(value))
    .find((value) => value && !GENERIC_LAYOUT_FAILURE_RE.test(value) && !isLayoutTechnicalFailureMessage(value) && !isLayoutOptimisticSuccessMessage(value))
  return message || layoutReadUnavailableMessage()
}

function layoutReadUnavailableMessage() {
  return h5Text('layout_read_unavailable') || 'Page data is temporarily unavailable. Please try again later.'
}

function layoutEntryUnavailableMessage() {
  return h5Text('layout_entry_unavailable') || 'Game entry is temporarily unavailable. Please try again later.'
}

function layoutMarkerToken(value) {
  return safeString(value).trim().toLowerCase()
}

function compactLayoutMarker(value) {
  return layoutMarkerToken(value).replace(/[\s_-]+/g, '')
}

function isLayoutTechnicalFailureMessage(value) {
  return TECHNICAL_LAYOUT_FAILURE_RE.test(safeString(value))
}

function isLayoutOptimisticSuccessMessage(value) {
  const token = layoutMarkerToken(value)
  if (!token) return false
  return ['ok', 'success', 'successful', 'succeeded', 'done', 'complete', 'completed'].includes(token) ||
    token.includes('成功')
}

function isLayoutUnavailableToken(value) {
  const token = layoutMarkerToken(value)
  const compact = compactLayoutMarker(value)
  return Boolean(token) && (
    token.includes('技术错误') ||
    token.includes('技术异常') ||
    token.includes('technical error') ||
    token.includes('technical_error') ||
    token.includes('technical exception') ||
    token.includes('technical_exception') ||
    token.includes('technical marker') ||
    token.includes('technical_marker') ||
    compact.includes('technicalmarker') ||
    compact.includes('routeunavailable') ||
    compact.includes('readunavailable') ||
    compact.includes('readblocked') ||
    compact.includes('readfailure') ||
    compact.includes('dataunavailable') ||
    compact.includes('backendblocked') ||
    compact.includes('backendfailure') ||
    compact.includes('actionblocked') ||
    compact.includes('writeblocked') ||
    compact.includes('notimplemented') ||
    compact.includes('notsupported') ||
    compact.includes('unsupported') ||
    compact.includes('unimplemented') ||
    compact.includes('fallback') ||
    compact.includes('mock') ||
    token.includes('route unavailable') ||
    token.includes('read unavailable') ||
    token.includes('read blocked') ||
    token.includes('read failure') ||
    token.includes('data unavailable') ||
    token.includes('backend blocked') ||
    token.includes('backend failure') ||
    token.includes('action blocked') ||
    token.includes('write blocked') ||
    token === 'blocked' ||
    token === 'rejected' ||
    token === 'unavailable'
  )
}

function isLayoutActiveFlag(value) {
  if (value === true || value === 1) return true
  return ['true', '1', 'yes', 'on'].includes(layoutMarkerToken(value)) ||
    isLayoutUnavailableToken(value)
}

function isLayoutUnavailableFlagKey(key) {
  const compact = compactLayoutMarker(key)
  return LAYOUT_UNAVAILABLE_FLAG_KEYS.some((marker) => compactLayoutMarker(marker) === compact)
}

function isLayoutUnavailableTextKey(key) {
  const compact = compactLayoutMarker(key)
  return LAYOUT_UNAVAILABLE_TEXT_KEYS.some((marker) => compactLayoutMarker(marker) === compact)
}

function hasLocalLayoutEntryUnavailableMarker(payload, depth = 0, seen = new Set()) {
  if (!payload || typeof payload !== 'object' || depth > 6 || seen.has(payload)) return false
  seen.add(payload)
  if (Array.isArray(payload)) {
    return payload.some(item => hasLocalLayoutEntryUnavailableMarker(item, depth + 1, seen))
  }
  return Object.keys(payload).some((key) => {
    const value = payload[key]
    if (isLayoutUnavailableFlagKey(key) && isLayoutActiveFlag(value)) return true
    if (isLayoutUnavailableToken(key) && isLayoutActiveFlag(value)) return true
    if (value && typeof value === 'object') return hasLocalLayoutEntryUnavailableMarker(value, depth + 1, seen)
    return isLayoutUnavailableTextKey(key) && isLayoutUnavailableToken(value)
  })
}

export default {
  components: {
    // TopDownload,
    TopNav,
    TabBarIcon
  },
  name: 'index',
  computed: {
    // 获取当前路由前缀，确保 tabbar 路径正确匹配
    routePrefix() {
      return this.$route.params.prefix || safeGetStorageItem(getLocalStorage(), 'country') || ''
    },
    // 底部导航列表
    tabList() {
      return buildLayoutTabEntries(this.routePrefix, this.$lang)
    },
    announcementText() {
      return this.primaryAnnouncementText(this.latestAnnouncement) || this.$lang.common_txt357
    },
    announcementListForDisplay() {
      return this.announcementList
        .map((item) => ({
          ...item,
          title: safeString(item.title),
          content: safeString(item.content)
        }))
        .filter((item) => item.content || item.title)
    }
  },
  data() {
    return {
      active: 0,
      // images2: [
      //   `https://file.kk.game/static/${this.getCurrency}/1.png`
      // ],
      images: [
        require('@/assets/img/lottery/lottba1.png'),
        require('@/assets/img/lottery/lottba2.png'),
        require('@/assets/img/lottery/lottba3.png'),
        require('@/assets/img/lottery/lottba4.png')
      ],
      agree2: false,
      agree: false,
      MenList: [
        {
          img: require('@/assets/img/home/men_1.png'),
          name: this.$lang.common_txt138
        },
        {
          img: require('@/assets/img/home/men_2.png'),
          name: this.$lang.common_txt139
        }
      ],
      isFjShow: true,
      isFjShow2: true,
      showDialog: false,
      isShowPopup: false,
      isShowPopup2: false,
      timer: null,
      showPopup: false, //登录弹窗开关
      // tabBar: [
      //   {
      //     title: this.$lang.Início,
      //     to: '/home',
      //     img: require('@/assets/img/menu_home_original.png'),
      //     img_a: require('@/assets/img/menu_home_click.png')
      //   },
      //   {
      //     title: this.$lang.Depósito,
      //     to: '/rechargeCont',
      //     img: require('@/assets/img/menu_wallet_original.png'),
      //     img_a: require('@/assets/img/menu_wallet_click.png')
      //   },
      //   {
      //     title: this.$lang.common_txt26,
      //     to: '/Crowdfunding',
      //     img: require('@/assets/img/menu_agent_original.png'),
      //     img_a: require('@/assets/img/menu_agent_click.png')
      //   },
      //   {
      //     title: this.$lang.common_txt23,
      //     to: '/Support',
      //     img: require('@/assets/img/menu_activity_original.png'),
      //     img_a: require('@/assets/img/menu_activity_click.png')
      //   },

      //   {
      //     title: this.$lang.Meu,
      //     to: '/mine',
      //     img: require('@/assets/img/menu_personal_original.png'),
      //     img_a: require('@/assets/img/menu_personal_click.png')
      //   }
      // ],
      // selectMenIndex: this.$route.path === '/home' ? 1 : 0
      selectMenIndex: 0,
      isff: true,
      isff2: false,
      currentBannerIndex: 0,
      bannerList: [],
      bannerReadError: '',
      latestAnnouncement: null,
      announcementList: [],
      showNoticePopup: false
    }
  },
  watch: {
    // 监听路由变化，同步 tab 高亮
    $route: {
      handler(to) {
        this.syncActiveFromPath(to.path)

        if (to.query.isValue === 'isLogin' && !safeGetStorageItem(getLocalStorage(), 'token')) {
          this.showPopup = true
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      scrollWindowTop()
    })
    // 页面加载时判断是否需要显示弹窗
    this.checkPopupStatus()
    if (this.shouldOpenRegisterAwardPopup()) {
      this.ActivitygetRegisterAward()
    }
    const today = readTodayString()

    if (safeGetStorageItem(getSessionStorage(), 'neverShowToday2') === today) {
      this.showDialog = false
    } else if (safeGetStorageItem(getLocalStorage(), 'neverShow2')) {
      // 检查永久不显示
      this.showDialog = false
    } else {
      this.showDialog = true
    }

    // 全局监听登录弹窗事件（未登录接口、活动页等场景统一触发）
    this.$bus.$on('openLogin', this.handleOpenLogin)
    this.$nextTick(() => {
      if (consumeOpenLoginAfterPlatformSwitch() && this.$bus) {
        this.$bus.$emit('openLogin')
      }
    })
  },
  beforeDestroy() {
    this.$bus.$off('openLogin', this.handleOpenLogin)
  },
  async created() {
    this.fetchSystemAnnouncement()
    this.fetchBannerList()
    if (this.$route.query.id) {
      safeSetStorageItem(getLocalStorage(), 'id', this.$route.query.id)
      await this.GetInvitationID()
    }
    this.saveFbExpand()
  },
  methods: {
    saveFbExpand() {
      if (safeGetStorageItem(getLocalStorage(), 'fbExpand')) return
      try {
        const value =
          this.$pixel && this.$pixel.getUrlFBParams
            ? safeString(this.$pixel.getUrlFBParams()).replace('#/home?', '&')
            : ''
        if (value) {
          safeSetStorageItem(getLocalStorage(), 'fbExpand', value)
        }
      } catch (e) {
        safeRemoveStorageItem(getLocalStorage(), 'fbExpand')
      }
    },
    syncActiveFromPath(path = this.$route.path) {
      this.active = activeTabIndexFromPath(path)
    },
    handleOpenLogin() {
      this.showPopup = true
    },
    hasLayoutEntryUnavailableMarker(payload) {
      return hasLocalLayoutEntryUnavailableMarker(payload)
    },
    responseMessage(data, fallback) {
      const safeFallback = layoutFallbackMessage(fallback, this.$lang.network_error, this.$lang.common_txt114)
      const message = responseFailMessage(data, safeFallback)
      if (this.hasLayoutEntryUnavailableMarker(data)) {
        return layoutFallbackMessage(message, safeFallback)
      }
      return layoutFallbackMessage(message)
    },
    primaryAnnouncementText(announcement) {
      const last = safeObject(announcement)
      return safeString(last.content) || safeString(last.title)
    },
    normalizeAnnouncementList(source) {
      const content = safeObject(source)
      const rows = content.announcementList || content.list || content.dataList || content.records || content.items || []
      return Array.isArray(rows) ? rows.map((item) => safeObject(item)) : []
    },
    async fetchSystemAnnouncement() {
      try {
        const data = await SystemAnnouncement({})
        if (!isOkResponse(data)) {
          this.latestAnnouncement = null
          this.announcementList = []
          return
        }
        const content = responseContent(data)
        const last = safeObject(content.last)
        const list = this.normalizeAnnouncementList(content)
        this.latestAnnouncement = this.primaryAnnouncementText(last) ? last : null
        this.announcementList = list
      } catch (e) {
        this.latestAnnouncement = null
        this.announcementList = []
      }
    },
    // 处理 tab 点击
    handleTabClick(item, index) {
      if (this.hasLayoutEntryUnavailableMarker(item)) {
        this.$toast({
          message: this.responseMessage(item, layoutEntryUnavailableMessage()),
          icon: 'cross'
        })
        this.syncActiveFromPath()
        return
      }
      if (isProtectedLayoutTab(item.key)) {
        this.checkLoginAndProceed(item.to, index)
        return
      }
      this.active = index
      // 跳转路由
      if (this.$route.path !== item.to) {
        this.$router.push(item.to)
      }
    },
    // 检查登录状态
    async checkLoginAndProceed(to, index) {
      if (!safeGetStorageItem(getLocalStorage(), 'token')) {
        showLogin(this)
        this.syncActiveFromPath()
        return
      }
      try {
        const data = await Init()
        if (isNeedLogin(data)) {
          safeRemoveStorageItem(getLocalStorage(), 'token')
          showLogin(this)
          this.syncActiveFromPath()
          return
        }
        this.active = index
        if (this.$route.path !== to) {
          this.$router.push(to)
        }
      } catch (e) {
        this.active = index
        if (this.$route.path !== to) {
          this.$router.push(to)
        }
      }
    },
    async GetInvitationID() {
      try {
        const data = await GetInvitationID({
          inviteCode: safeGetStorageItem(getLocalStorage(), 'id')
        })
        const content = responseContent(data)
        if (isOkResponse(data) && content.invitCode) {
          safeSetStorageItem(getLocalStorage(), 'id', content.invitCode)
        }
      } catch (e) {
        safeRemoveStorageItem(getLocalStorage(), 'id')
      }
    },
    goToDetail3(i) {
      if (i === 0) {
        this.$jumpTo('/Crowdfunding')
      } else if (i === 1) {
        this.$jumpTo('/Alliance')
      } else if (i === 2) {
        this.$jumpTo('/vipSignIn')
      } else if (i === 3) {
        this.$jumpTo('/redPacket')
      } else if (i === 4) {
        this.$jumpTo('/referFriend')
      } else if (i === 5) {
        this.$jumpTo('/cashBack')
      } else if (i === 6) {
        this.$jumpTo('/signIn')
      } else if (i === 7) {
        this.$jumpTo('/activityFistRecharge')
      } else if (i === 8) {
        this.$jumpTo('/Support')
      }
    },
    onBannerChange(index) {
      this.currentBannerIndex = index
    },
    bannerPrev() {
      const swipe = this.$refs.bannerSwipe
      const length = this.bannerList.length
      if (!swipe || !length) return
      if (this.currentBannerIndex > 0) {
        swipe.swipeTo(this.currentBannerIndex - 1)
      } else {
        swipe.swipeTo(length - 1)
      }
    },
    bannerNext() {
      const swipe = this.$refs.bannerSwipe
      const length = this.bannerList.length
      if (!swipe || !length) return
      if (this.currentBannerIndex < length - 1) {
        swipe.swipeTo(this.currentBannerIndex + 1)
      } else {
        swipe.swipeTo(0)
      }
    },
    async fetchBannerList() {
      try {
        const data = await GetBannerList({})
        if (isReadableOkResponse(data)) {
          const content = responseContent(data)
          this.bannerList = sortByOrderDesc(content.bannerList || content.list || content.records || content.items)
            .map((item) => safeObject(item))
            .filter((item) => item.advertisementImg && !this.hasLayoutEntryUnavailableMarker(item))
          this.bannerReadError = ''
          return
        }
        this.bannerReadError = this.responseMessage(data, this.$lang.banner_load_failed || 'Failed to load banners.')
      } catch (e) {
        this.bannerReadError = this.responseMessage(null, this.$lang.banner_load_failed || 'Failed to load banners.')
      }
    },
    onBannerClick(item) {
      if (this.hasLayoutEntryUnavailableMarker(item)) {
        this.$toast({
          message: this.responseMessage(item, layoutEntryUnavailableMessage()),
          icon: 'cross'
        })
        return
      }
      openCurrentUrl(safeObject(item).extendJson)
    },
    closeActive() {
      this.showDialog = false
    },
    closeActive2() {
      this.showDialog = true
    },
    shouldOpenRegisterAwardPopup() {
      if (!this.token) return false
      const today = readTodayString()
      if (safeGetStorageItem(getSessionStorage(), 'neverShowToday') === today) return false
      if (safeGetStorageItem(getLocalStorage(), 'neverShow') === 'true') return false
      return true
    },
    markerToken(value) {
      return String(value == null ? '' : value).trim().toLowerCase()
    },
    isTrueFlag(value) {
      if (value === true || value === 1) return true
      return ['1', 'true', 'yes', 'on'].includes(this.markerToken(value))
    },
    isFalseFlag(value) {
      if (value === false || value === 0) return true
      return ['0', 'false', 'no', 'off'].includes(this.markerToken(value))
    },
    isRegisterAwardOkValue(value) {
      if (value === true) return true
      return ['ok', 'success', 'successful', 'succeeded', 'completed', '0', '00', '0000', '200'].includes(this.markerToken(value))
    },
    isRegisterAwardOkResponse(data, content) {
      if (!data || isNeedLogin(data)) return false
      return [
        data.status,
        data.state,
        data.result,
        data.code,
        data.errorCode,
        data.success,
        content.status,
        content.state,
        content.result,
        content.code,
        content.errorCode,
        content.success
      ].some(value => this.isRegisterAwardOkValue(value))
    },
    isRegisterAwardPopupAvailable(content) {
      const explicitClaimable = this.isTrueFlag(content.claimable) || this.isTrueFlag(content.canReceive)
      const blocked = this.hasLayoutEntryUnavailableMarker(content) ||
        this.isTrueFlag(content.readOnlyQuery) ||
        this.isTrueFlag(content.readOnly) ||
        this.isTrueFlag(content.readOnlyMode) ||
        this.isTrueFlag(content.read_only_mode) ||
        this.isTrueFlag(content.routeUnavailable) ||
        this.isTrueFlag(content.route_unavailable) ||
        this.isTrueFlag(content.readUnavailable) ||
        this.isTrueFlag(content.read_unavailable) ||
        this.isTrueFlag(content.technicalMarker) ||
        this.isTrueFlag(content.technical_marker) ||
        this.isTrueFlag(content.readBlocked) ||
        this.isTrueFlag(content.read_blocked) ||
        this.isTrueFlag(content.readFailure) ||
        this.isTrueFlag(content.read_failure) ||
        this.isTrueFlag(content.writeBlocked) ||
        this.isTrueFlag(content.write_blocked) ||
        this.isTrueFlag(content.backendBlocked) ||
        this.isTrueFlag(content.backend_blocked) ||
        this.isTrueFlag(content.backendFailure) ||
        this.isTrueFlag(content.backend_failure) ||
        this.isTrueFlag(content.rewardBackendBlocked) ||
        this.isTrueFlag(content.dataUnavailable) ||
        this.isTrueFlag(content.data_unavailable) ||
        this.isTrueFlag(content.fallback) ||
        this.isTrueFlag(content.mock) ||
        this.isTrueFlag(content.mockMode) ||
        this.isTrueFlag(content.mock_mode) ||
        this.isFalseFlag(content.rewardWritable)
      return Number(content.receiveStatus) === 1 && explicitClaimable && !blocked
    },
    async ActivitygetRegisterAward() {
      try {
        const data = await ActivitygetRegisterAward()
        const content = responseContent(data)
        this.isShowPopup2 = this.isRegisterAwardOkResponse(data, content) &&
          !this.hasLayoutEntryUnavailableMarker(data) &&
          this.isRegisterAwardPopupAvailable(content)
      } catch (e) {
        this.isShowPopup2 = false
      }
    },
    goToMen(i) {
      this.selectMenIndex = i
      this.$jumpTo('/home')
    },
    async goTofj(i) {
      if (i === 1) {
        try {
          const data = await GetCsLink()
          openCustomerServiceUrl(data, 'telegram')
        } catch (e) {
          openCustomerServiceUrl(null, 'telegram')
        }
      }
      // if (i === 1) {
      //   this.$router.push('./activityFistRecharge')
      // } else if (i === 2) {
      //   this.$router.push('./cashBack')
      // }
    },
    closeF2(i) {
      if (i === 1) {
        this.isFjShow = false
      } else if (i === 2) {
        this.isFjShow2 = false
      }
    },
    closeF() {
      if (this.agree) {
        // 今日不显示
        const today = new Date().toISOString().split('T')[0]
        safeSetStorageItem(getSessionStorage(), 'neverShowToday2', today)
      }
      if (this.agree2) {
        // 永久不显示
        safeSetStorageItem(getLocalStorage(), 'neverShow2', 'true')
      }
      if (this.isff2) {
        this.showDialog = false
      }
      this.isff = false
      if (!this.isff) {
        this.isff2 = true
        return
      }
    },
    submit2() {
      safeRemoveStorageItem(getLocalStorage(), 'isRegister')
      this.showDialog = false
      // this.$router.push('/recharge')
      this.$jumpTo('/rechargeCont')
    },
    getLoging() {
      this.showPopup = true
    },
    LoginKey() {
      this.showPopup = true
    },
    // 检查是否需要显示弹窗
    checkPopupStatus() {
      const today = this.getTodayString()
      const lastShownDate = safeGetStorageItem(getLocalStorage(), 'popupLastShownDate')
      const isClosedToday = safeGetStorageItem(getLocalStorage(), 'popupClosedToday') === 'true'

      // 如果今天已经显示过或者今天关闭过，则不显示
      if (lastShownDate === today || isClosedToday) {
        this.isShowPopup = false
        // this.isShowPopup2 = false
      } else {
        this.isShowPopup = true
        // this.isShowPopup2 = true

        // 记录今天已经显示过弹窗
        safeSetStorageItem(getLocalStorage(), 'popupLastShownDate', today)
      }
      // if (safeGetStorageItem(getLocalStorage(), 'isRegister') === 'isRegister') {
      //   this.showDialog = true
      // }
    },
    // 打开弹窗
    openPopup() {
      const today = this.getTodayString()
      // 如果今天没有显示过弹窗且没有被关闭过，则可以手动打开
      if (
        !safeGetStorageItem(getLocalStorage(), 'popupLastShownDate') ||
        safeGetStorageItem(getLocalStorage(), 'popupLastShownDate') !== today
      ) {
        this.isShowPopup = true
        // this.isShowPopup2 = true
        safeSetStorageItem(getLocalStorage(), 'popupLastShownDate', today)
      }
    },
    // 关闭弹窗
    closePopup() {
      this.isShowPopup = false
      // 记录今天关闭过弹窗
      safeSetStorageItem(getLocalStorage(), 'popupClosedToday', 'true')
    },
    // 获取当前日期字符串（格式：YYYY-MM-DD）
    getTodayString() {
      return readTodayString()
    },
    close() {},
    async GameBalanceList() {
      try {
        await GameBalanceList()
      } catch (e) {
        // Balance refresh is non-blocking for layout navigation.
      }
    },
    async WithdrawInit() {
      try {
        await WithdrawInit()
      } catch (e) {
        // Withdraw bootstrap is non-blocking for layout navigation.
      }
    },
    async VnRechargeInitS() {
      try {
        await VnRechargeInitS()
      } catch (e) {
        // Recharge bootstrap is non-blocking for layout navigation.
      }
    },
    // 登录
    async isLogin(i) {
      // 第一个tab点击后由 van-tabbar 的 route 属性自动处理路由跳转和高亮
      if (i === 0) return
      // 1. 通过 id 获取目标元素
      const target = getLayoutAnchorElement()
      if (!target) return // 防止 id 不存在报错
      try {
        target.scrollIntoView({
          behavior: 'auto', // 滚动行为：smooth（平滑）/ auto（瞬间，默认）
          block: 'start', // 对齐方式：start（顶部对齐）/ center（居中）/ end（底部对齐）
          inline: 'nearest' // 水平对齐（默认即可）
        })
      } catch (e) {
        // Ignore scroll failures in restricted browser shells.
      }
      if (i !== 2 && i !== 3) {
        try {
          const data = await Init()
          if (isNeedLogin(data)) {
            showLogin(this)
            this.timer = (this.timer || 0) + 1
          }
        } catch (e) {
          showLogin(this)
          this.timer = (this.timer || 0) + 1
        }
      }
      // this.$nextTick(() => {
      //   window.scrollTo(0, 0)
      // })
      if (i === 2 && safeGetStorageItem(getLocalStorage(), 'token')) {
        this.GameBalanceList()
        this.WithdrawInit()
      }
    }
  }
}
</script>

<style lang="less" scoped>
/* 公告栏 - 图中样式：深色背景、圆角、阴影、白字 */
.otag-gg {
  padding: 0 15px;
  margin-bottom: 4px;
}
::v-deep .van-notice-bar.notice-bar-style {
  background-color: #2c3643 !important;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  padding: 5px 15px;
  color: #ffffff;
  height: 30px;
}
::v-deep .van-notice-bar.notice-bar-style .van-notice-bar__content {
  color: #ffffff;
}
.notice-bar-text {
  color: #ffffff !important;
  font-size: var(--vk-fs-sm);
}
.notice-bar-icon {
  filter: brightness(1.1);
}

// .con-sw-bg {
//   background: url(../../assets/img/otgame/kuang_05.png) no-repeat;
//   background-size: 100% 100%;
//   height: 195px;
//   width: 96%;
//   margin: 0 auto;
//   left: 0;
//   right: 0;
//   position: absolute;
//   top: -10px;
// }
/* 自定义 van-tabbar 样式 */
/* PC 端样式 */
@media (min-width: 769px) {
  .custom-tabbar {
    width: var(--vk-pc-col);
    left: 50%;
    transform: translate(-50%, -50%);
    bottom: -30px;
  }
  .cont-redim {
    height: 477px !important;
    padding-top: 383px !important;
  }
  .cont-redim2 {
    height: 477px !important;
    padding-top: 383px !important;
  }
  .custom-popup2 {
    width: 370px !important;
  }
  ::v-deep .van-sticky--fixed {
    top: 110px !important;
  }
}
::v-deep .van-overlay {
  z-index: 1999 !important;
}
.custom-tabbar {
  z-index: 999;
  height: 60px;
  // background-color: @background-color;
  background: var(--vk-surface); /* 原 menu_bg.png(偏蓝紫)→ token 面色 */
  border-top: 1px solid var(--vk-border);
  width: 100%;
  max-width: var(--vk-pc-col);
  border-radius: 13px 13px 0 0;
  // box-shadow: 0 5px 10px rgba(255, 255, 255, 0.9); /* 阴影效果 */
  // ::v-deep > .van-tabbar-item:nth-child(3) {
  // height: 12px;
  // margin-top: 19px;
  // .van-tabbar-item__icon > img {
  //   width: 62px;
  //   height: 60px;
  // margin-top: 58px;
  // border-radius: 50%;
  // border-left: 1px solid #00f; /* 左边蓝色 */
  // border-right: 1px solid #f0f; /* 右边粉色 */
  // }
  // }
}
::v-deep .van-tabbar-item {
  color: var(--vk-t2);
  transition: none;
}
::v-deep .van-tabbar-item .vk-tab-icon {
  margin: 0 auto; /* 图标在 50px 旧占位换成 24px 后保持水平居中 */
}
::v-deep .van-tabbar-item--active {
  color: var(--vk-brand) !important; /* 底部 tabbar 激活=火焰橙 */
  background-color: transparent;
  border-radius: 13px 13px 0 0;
  animation: none;
  .van-tabbar-item__text {
    position: relative;
    font-weight: 700; /* a11y:激活态不只靠颜色区分(WCAG 1.4.1) */
  }
  /* 顶部火焰橙指示条,补足激活态可辨识性(WCAG 1.4.1;图标已为 currentColor SVG,随激活色切换) */
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 24px;
    height: 3px;
    border-radius: 0 0 3px 3px;
    background: var(--vk-brand);
  }
}
.custom-popup2 {
  width: 86%;
  text-align: center;
  background-color: transparent; /* 设置背景色 */
  // z-index: 2004 !important;
  .cont-redim {
    // padding-top: 330px;
    background: url(../../assets/img/common/syhd.png) no-repeat;
    background-size: 100% 100%;
    height: 420px;
    border-radius: 15px;
  }
  .cont-redim2 {
    // padding-top: 330px;
    background: url(../../assets/img/common/home_111.png) no-repeat;
    background-size: 100% 100%;
    height: 450px;
    border-radius: 15px;
  }

  ::v-deep .van-checkbox__icon .van-icon {
    border: none;
  }
  ::v-deep .van-checkbox__icon--checked .van-icon {
    background-color: var(--vk-brand) !important;
  }
  .van-overlay {
    z-index: 2001 !important;
  }
}
.fj-cont {
  position: fixed;
  bottom: 160px;
  right: 20px;
  text-align: right;
  z-index: 999;
}
.fj-cont-i {
  animation: enlargeAndShake 1.8s ease-in-out infinite;
  transform-origin: bottom; /* 将旋转中心点设置为底部 */
}
@keyframes enlargeAndShake {
  0% {
    transform: scale(1) rotate(0deg);
  }
  20% {
    transform: scale(1.2) rotate(0deg);
  }
  40% {
    transform: scale(1.2) rotate(-10deg); /* 放大并左晃 */
  }
  60% {
    transform: scale(1.2) rotate(10deg); /* 放大并右晃 */
  }
  80% {
    transform: scale(1.2) rotate(-10deg); /* 放大并左晃 */
  }
  100% {
    transform: scale(1.2) rotate(0deg);
  }
}
.select-Men {
  background: var(--vk-brand) !important; /* 激活=火焰橙(铁律①,去蓝) */
  color: #ffffff !important;
}
.content-swiper--img {
  width: 94%; /* 图片宽度铺满轮播项 */
  margin: 0 auto;
  height: 182px; /* 图片高度等于轮播容器高度 */
  // object-fit: cover; /* 核心：保持比例裁剪图片，填满容器（避免拉伸变形） */
  display: block; /* 去除图片底部默认空白 */
  border-radius: 10px;
}
.swipe-fixed-height {
  width: 100%; /* 左右铺满父容器（通常是屏幕宽度） */
  /* 清除默认样式干扰 */
  margin: 0;
  padding: 0;
}
.content-swiper-bg {
  position: relative;
  ::v-deep .van-swipe__indicator {
    width: 25px;
    border-radius: 12px;
    color: transparent !important;
  }
  ::v-deep .van-swipe__indicator--active {
    // width: 35px;
    color: #ffffff !important;
  }
  ::v-deep .van-swipe__indicator--active {
    background: #ffffff !important;
  }
}
.layout-banner-read-error {
  width: 94%;
  margin: 8px auto 10px;
  padding: 8px 10px;
  border-radius: 6px;
  background: rgba(255, 193, 7, 0.12);
  color: #ffd36a;
  font-size: var(--vk-fs-xs);
  line-height: 1.4;
}
.banner-arrow-wrap {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  padding: 0 8px;
  z-index: 10;
  pointer-events: none;
}
.banner-arrow {
  width: 32px;
  height: 32px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  pointer-events: auto;
  transition: opacity 0.2s;
}
.banner-arrow:active {
  opacity: 0.7;
}
.banner-indicators {
  position: absolute;
  bottom: 8px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  gap: 6px;
  z-index: 10;
}
.banner-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  transition: all 0.3s;
}
.banner-dot.active {
  background: #ffffff;
  width: 18px;
  border-radius: 3px;
}
/* 公告弹窗 */
.notice-popup {
  background: #252936 !important;
  width: 85%;
  max-width: 400px;
  border-radius: 12px !important;
}
.notice-popup__content {
  padding: 20px;
}
.notice-popup__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  span {
    flex: 1;
    margin-left: 8px;
    font-size: var(--vk-fs-md);
    font-weight: bold;
    color: #ffffff;
  }
}
.notice-popup__body {
  color: #c0c6d8;
  font-size: var(--vk-fs-base);
  line-height: 1.6;
  max-height: 50vh;
  overflow-y: auto;
}
</style>
